angular.module("rt.encodeuri",[]).filter("encodeUri",["$window",function(a){return a.encodeURIComponent}]);